//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;


var mlsdata = require("./mls.geo.json");

var geojson;

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

function commafy( num ) {
 num = num.toString();
 if (!num) return;
 if (num.length >= 4) {
   num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
 }
 return num;
}
function highlightFeature(e) {
    var layer = e.target;

    layer.setStyle({
        weight: 4,
        color: '#666',
        fillOpacity: 0.5
    });

    if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
    }
}
function resetHighlight(e) {
    geojson.resetStyle(e.target);
}

var onEachFeature = function(feature, layer) {
    areaData[feature.properties.number].price2 = commafy(Number(areaData[feature.properties.number].price.toFixed()));
    areaData[feature.properties.number].change2 = (Number(areaData[feature.properties.number].change * 100).toFixed(1));
    // if (areaData[feature.properties.number].rel_to_peak != "NA") {
    // areaData[feature.properties.number].peak2 = (areaData[feature.properties.number].rel_to_peak * 100).toFixed(1)};
    // areaData[feature.properties.number].price_ytd2 = commafy(areaData[feature.properties.number].price_ytd);

  if (feature.properties) {
    layer.bindPopup(ich.popup(areaData[feature.properties.number]
      ))
  };
  layer.on({
    mouseover: highlightFeature,
    mouseout: resetHighlight
});
};

map.scrollWheelZoom.disable();




var getColor = function(area) {
  if (area.change >= .99) {
    return "#8e305d";
  }
  if (area.change >= .12) {
    return "#cc5694";
  }
  if (area.change >= .06) {
    return "#f993b1";
  }
  if (area.change >= 0) {
    return "#fcc5c2";
  }
  if (area.change >= -0.099) {
    return "#e6dfef";
  }
  if (area.change < 0.1) {
    return "#c0b6d8";
  }
  return "transparent";
}

geojson = L.geoJson(mlsdata, {
  style: function(feature) {
    if (!areaData[feature.properties.number].change) {
      return {
        fillColor: "transparent",
        weight: 1,
        opacity: 0,
        color: "white",
        fillOpacity: 0
      }
    } else if (feature.properties.number) {
      return {
        fillColor: getColor(areaData[feature.properties.number]),
        weight: 1,
        opacity: 1,
        color: "white",
        fillOpacity: 0.7
      }
    } else {
      return {
        fillColor: "gray",
        weight: 1,
        opacity: 1,
        color: "white",
        fillOpacity: 0.7
      }
    }
  },
onEachFeature: onEachFeature
}).addTo(map);

// map.fitBounds(geojson.getBounds());

// map.createPane("top");
// map.getPane("top").style.zIndex = 650;
// var topLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png', {
//   pane: "top",
// }).addTo(map);
